import { FC } from 'react';
import { Typography } from '@mui/material';
import styles from './index.module.scss';

export const PayerDataDetailsModalContent: FC = () => {
	return (
		<div className={styles.content}>
			<Typography mb="8px" variant="subtitle1">
				Навіщо вводити дані?
			</Typography>
			<Typography color="var(--color-neutral-500)" variant="body2">
				Це вимога НБУ для проведення платежів.
				<br />
				Введіть дані один раз — надалі ми підставимо їх автоматично
			</Typography>
		</div>
	);
};
